import { TrackingAnalytics } from './TrackingAnalytics';

export const EnterpriseSettings = {

  updateOrgName () {
    TrackingAnalytics.send('ES-Basics-Updates Org Name');
  },
  addDomainName () {
    TrackingAnalytics.send('ES-Basics-Add New Domain Name');
  },
  addAdmin () {
    TrackingAnalytics.send('ES-Admin-Add Admin');
  },
  newAdminsRejected (invalidEmails) {
    const props = {
      invalid_emails: invalidEmails
    };
    TrackingAnalytics.send('ES~Admin~New Admins Rejected', props);
  },
  showCoCToggled (checked) {
    const props = {
      showCOC: checked
    };
    TrackingAnalytics.send('ES-Show CoC toggled', props);
  },
  sortsAdmins (fieldToSortBy) {
    const props = {
      field_to_sort_by: fieldToSortBy
    };
    TrackingAnalytics.send('ES-Admin-Sorts Admins', props);
  },
  sortsAdminsByName () {
    this.sortsAdmins('name');
  },
  sortAdminsByEmail () {
    this.sortsAdmins('email');
  },
  sortAdminsByDateAdded () {
    this.sortsAdmins('date added');
  },
  sortAdminsByRole () {
    this.sortsAdmins('role');
  },
  removesAdmin () {
    TrackingAnalytics.send('ES-Admin-Removes Admin');
  },
  removeSelfAdmin (exitState) {
    const props = {
      exit_state: exitState
    };
    TrackingAnalytics.send('ES~Admin~Remove Myself as Admin Modal', props);
  },
  removeSelfAdminOK () {
    this.removeSelfAdmin('OK');
  },
  removeSelfAdminCancel () {
    this.removeSelfAdmin('cancel');
  },
  whyAddAdminError () {
    TrackingAnalytics.send('ES-Admin-Why Add Admin Error');
  },
  transferOwnership () {
    TrackingAnalytics.send('ES-Admin-Transfer Ownership');
  },
  transferOwnershipModal (exitState) {
    const props = {
      exit_state: exitState
    };
    TrackingAnalytics.send('ES~Admin~Transfer Ownership Modal', props);
  },
  transferOwnershipModalOK () {
    this.transferOwnershipModal('OK');
  },
  transferOwnershipModalCancel () {
    this.transferOwnershipModal('cancel');
  },
  editLinkType (linkType) {
    const props = {
      link_type: linkType
    };
    TrackingAnalytics.send('ES-Config-Edit Share Link Type', props);
  },
  restrictCreation (restrictCreation) {
    const props = {
      restrict_creation: restrictCreation
    };
    TrackingAnalytics.send('ES-Admin-Toggle Restrict Creation', props);
  },
  restrictCreationModal (exitState) {
    const props = {
      exit_state: exitState
    };
    TrackingAnalytics.send('ES~Config~Restrict Creation Modal', props);
  },
  restrictCreationModalOK () {
    this.restrictCreationModal('OK');
  },
  restrictCreationModalCancel () {
    this.restrictCreationModal('cancel');
  },
  learnMoreRestrictCreation () {
    TrackingAnalytics.send('ES-Config-Learn More Restrict Creation Modal');
  },
  learnMoreCOC () {
    TrackingAnalytics.send('ES-Config-Learn More Code of Conduct');
  },
  addCreator () {
    TrackingAnalytics.send('ES-Creator-Add creator');
  },
  sortsCreators (fieldToSortBy) {
    const props = {
      field_to_sort_by: fieldToSortBy
    };
    TrackingAnalytics.send('ES-Creator-Sort Creators', props);
  },
  sortsCreatorsByName () {
    this.sortsCreators('name');
  },
  sortsCreatorsByEmail () {
    this.sortsCreators('email');
  },
  sortsCreatorsByAdded () {
    this.sortsCreators('date authorized');
  },
  removeCreator () {
      TrackingAnalytics.send('ES-Creator-Remove Creator');
  },
  removeCreatorConfirmation () {
      TrackingAnalytics.send('ES-Creator-Remove Creator Confirmation');
  },
  newCreatorsRejected (invalidEmails) {
    const props = {
      invalid_emails: invalidEmails
    };
    TrackingAnalytics.send('ES~Creator~New Creators Rejected', props);
  },
  sendTestEmail () {
    TrackingAnalytics.send('ES-Delivery-Test Email');
  },
  testEmailEnRouteModal () {
    TrackingAnalytics.send('ES~Delivery~Test Email En Route Modal');
  },
  learnMoreTestEmail () {
    TrackingAnalytics.send('ES-Delivery-Learn More Test Email En Route Modal');
  },
  itChecklist () {
    TrackingAnalytics.send('ES-Delivery-IT Checklist');
  },
  contactUsDelivery () {
    TrackingAnalytics.send('ES-Delivery-Contact Us');
  },
  msTeamsIntegration () {
    TrackingAnalytics.send('ES-Integration-MS Teams');
  },
  slackIntegration () {
    TrackingAnalytics.send('ES-Integration-Slack');
  },
  standardAuth () {
    TrackingAnalytics.send('ES-Auth-Standard');
  },
  samlSSOAuth () {
    TrackingAnalytics.send('ES-Auth-SAML SSO');
  },
  settingsFromMetadataURL (settingType) {
    const props = {
      setting_type: settingType
    };
    TrackingAnalytics.send('ES-Auth-Settings from Metadata URL Dropdown', props);
  },
  learnMoreSAML () {
    TrackingAnalytics.send('ES-Auth-Learn More SAML SSO');
  }
};

